module.exports = __webpack_public_path__ + "static/media/logo-itau.bef173b9.svg";